module.exports = __webpack_public_path__ + "assets/img/btn-download-hover-60fc96c6.png";